export default __webpack_public_path__ + "img/d3a260d72d08c5774a2b63604478beb0.svg";